import React from "react";

class PlayedGamesItem extends React.Component {
	constructor(props) {
		super(props);
	}
	render() {
		return (
			<li data-id={this.props.id} data-type="fav">
				<a href={this.props.url}>
					<img
						height={window.mobile ? 60 : 30}
						width={window.mobile ? 60 : 50}
						src={this.props.img}
					/>
					{this.props.name}
				</a>
			</li>
		);
	}
}

class PlayedGames extends React.Component {
	constructor(props) {
		super(props);
	}
	render() {
		var rows = [];
		this.props.items.forEach((result, key) => {
			rows.push(
				<PlayedGamesItem
					key={key}
					id={result.id}
					url={result.url}
					img={result.img}
					name={result.name}
				/>
			);
		});
		if (!window.mobile) {
			return (
				<div>
					<a href="javascript:void(0);">
						<span className="s_icon_o" width="21" height="21" />
						{translate.last_played}
					</a>
					{this.props.items.length == 0 ? (
						<ul className="sub-menu" id="fav_submenu">
							<li>{translate.last_played_description}</li>
						</ul>
					) : (
						<ul className="sub-menu" id="fav_submenu">
							{rows}
						</ul>
					)}
				</div>
			);
		} else {
			if (this.props.items.length == 0) {
				return (
					<ul className="mm-listview">
						<li>{translate.last_played_description}</li>
					</ul>
				);
			} else {
				return <ul className="mm-listview">{rows}</ul>;
			}
		}
	}
}

export default PlayedGames;
